import i18next from 'i18next';
import {initReactI18next} from 'react-i18next';

import type {i18n as I18nType, Resource} from 'i18next';

export interface CreateI18nOptions {
  resources: Resource;
  lng?: string;
  fallbackLng?: string;
  defaultNS?: string;
  ns?: readonly string[];
  storageKey?: string;
}

export function createI18n({
  resources,
  lng,
  fallbackLng = 'he',
  defaultNS = 'common',
  ns,
  storageKey = 'i18nextLng'
}: CreateI18nOptions): I18nType {
  const i18n = i18next.createInstance();

  let savedLang: string | null = null;
  try {
    savedLang = localStorage.getItem(storageKey);
  } catch {
    // localStorage may be unavailable
  }

  i18n.use(initReactI18next).init({
    resources,
    lng: savedLang ?? lng ?? fallbackLng,
    fallbackLng,
    defaultNS,
    ns: ns ? [...ns] : [defaultNS],
    debug: false,
    interpolation: {
      escapeValue: false
    },
    initAsync: false
  });

  i18n.on('languageChanged', newLng => {
    try {
      localStorage.setItem(storageKey, newLng);
    } catch {
      // localStorage may be unavailable
    }
  });

  return i18n;
}
